export enum WebSocketEvents {
  AGENT_TOKEN_DELETE_STATUS_UPDATE = "AGENT_TOKEN_DELETE_STATUS_UPDATE",
  BULK_EDIT_STATUS_UPDATE = "BULK_EDIT_STATUS_UPDATE",
  INTEGRATION_AUDITLOG_CREATE = "INTEGRATION_AUDITLOG_CREATE",
  INTEGRATION_RESOURCE_CREATE = "INTEGRATION_RESOURCE_CREATE",
  REVOKE_PERMISSIONS_STATUS_UPDATE = "REVOKE_PERMISSIONS_STATUS_UPDATE",
  TICKET_AUDITLOG_CREATE = "TICKET_AUDITLOG_CREATE",
  TICKET_COMMENT_CREATE = "TICKET_COMMENT_CREATE",
  TICKET_STATUS_UPDATE = "TICKET_STATUS_UPDATE",
  USER_NEW_PENDING_TICKET = "USER_NEW_PENDING_TICKET",
  USER_PENDING_APPROVAL_CREATE = "USER_PENDING_APPROVAL_CREATE",
}

export enum WebSocketRooms {
  COMPANY = "subscribeUpdates",
  INTEGRATION = "subscribeIntegrationUpdates",
  TICKET = "subscribeTicketUpdates",
  USER = "subscribeUserUpdates",
}

export type TAgentTokenDeleteStatusUpdateData = {
  agentTokenId: string;
  error?: boolean;
};

export type TBulkActionErrorData = { error: true };
export type TBulkActionUpdateData = {
  model: "Integration" | "IntegrationResource" | "IntegrationResourceRole";
  progressPercentage: number;
  totalItems: number;
  updates: Record<string, unknown>;
};

export type TIntegrationAuditLogCreateData = {
  auditLog: Record<string, unknown>;
  integrationId: string;
};

export type TIntegrationResourceCreateData = {
  integrationId: string;
  integrationResource: Record<string, unknown>;
  integrationResourceId: string;
};

export type TRevokePermissionsUpdateData = {
  permissionId: string;
  revokeId: string;
  success: boolean;
};

export type TTicketAuditLogCreateData = {
  auditLog: Record<string, unknown>;
  ticketId: string;
};

export type TTicketCommentCreateData = {
  comment: Record<string, unknown>;
  ticketId: string;
};

export type TTicketStatusUpdateData = {
  ticket: Record<string, unknown>;
  ticketId: string;
};

export type TUserNewPendingTicketData = {
  ticket: Record<string, unknown>;
  userId: string;
};

export type TUserPendingApprovalCreateData = {
  ticket: Record<string, unknown>;
  userId: string;
};
